import { useRouter } from 'next/navigation';

type EditIconProps = {
  location: string;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const EditIcon = ({
  location,
  className = '',
  disabled = false,
  onClick,
}: EditIconProps) => {
  const router = useRouter();

  const clickHandler = () => {
    if (disabled) return;

    onClick?.();

    const [url, hash] = location.split('#');

    router.push(url);

    if (hash) {
      window.location.hash = hash;
    }
  };

  return (
    <div
      className={`m-2 ${
        disabled ? '!cursor-not-allowed' : 'cursor-pointer'
      } flex gap-1 items-center h-[36px] ${className}`}
      onClick={clickHandler}
    >
      <svg
        className="h-[18px] w-[18px] md:h-[25px] md:w-[25px]"
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          d="M11.5 4.5H4C2.34315 4.5 1 5.84315 1 7.5V24C1 25.6569 2.34315 27 4 27H20.5C22.1569 27 23.5 25.6569 23.5 24V16.5M21.3787 2.37868C22.5503 1.20711 24.4497 1.20711 25.6213 2.37868C26.7929 3.55025 26.7929 5.44975 25.6213 6.62132L12.7426 19.5H8.5L8.5 15.2574L21.3787 2.37868Z"
          stroke="#828282"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <span className="block mt-[4px] text-[#828282] text-15 md:text-17 font-semibold">
        Edit
      </span>
    </div>
  );
};

export default EditIcon;


